import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { HomecareProposalPage } from "@/features/public/homecare-proposal";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * Deliberately OUTSIDE the `(member)` route group: this is a homeowner-facing
 * page opened from an emailed link, so it must not inherit the group's
 * IntercomProvider (no support chat bubble for customers) or GTM analytics.
 * It still sits under the root providers (query client, platform client).
 *
 * `view` persists the tab (category | month | calendar) across refresh and
 * link-sharing. Lenient string, not an enum — a strict enum on a URL param
 * throws SearchParamError and crashes the page; the component narrows it.
 */
const searchSchema = z.object({
  view: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/homecare-proposal/$proposalId")({
  validateSearch: searchSchema,
  component: HomecareProposalPage,
  head: () => ({
    meta: [
      { title: "Birdwatch - Service Plan Quote" },
      { name: "description", content: "Birdwatch - Service Plan Quote" },
    ],
  }),
});
